import { object, string, number } from 'yup'

export const contact_us_schema = object({
    name: string().required('Required'),
    email: string().email('Invalid Email').required('Required'),
    phone: number().typeError('Invalid Phone').required('Required'),
    company: string().required('Required'),
    message: string().required('Required')
});